// START IMPORTS
import { CustomIcons, Theme } from '@ltvco/refresh-lib/theme';
import { IconContainer } from '@ltvco/refresh-lib/v2';
import {
  HelpRounded,
  LightbulbRounded,
  WarningRounded,
} from '@mui/icons-material';
// END IMPORTS

// START HELPER_FUNCTIONS
export const getDarkWebNavLinkData = (theme: Theme) => {
  return [
    {
      href: '#dark-web-overview-section',
      sectionId: '#dark-web-overview-section',
      labelText: 'Overview',
      icons: [
        <IconContainer
          bgColor={theme.palette.primary.main}
          width={36}
          height={36}
          icon={
            <CustomIcons.DarkWebIcon
              key="dark-web-overview-section"
              sx={{
                color: theme.palette.background.paper,
                marginLeft: 0.75,
                fontSize: '1.5rem',
              }}
            />
          }
        />,
      ],
      name: 'dark-web-overview-section',
    },
    {
      href: '#dark-web-breaches-section',
      sectionId: '#dark-web-breaches-section',
      labelText: 'Breaches',
      icons: [
        <WarningRounded
          key="dark-web-breaches-section"
          sx={{ color: theme.palette.primary.main }}
        />,
      ],
      hideReportItemsCount: true,
    },
    {
      href: '#dark-web-breach-tips-section',
      sectionId: '#dark-web-breach-tips-section',
      labelText: 'Breach Tips',
      icons: [
        <LightbulbRounded
          key="dark-web-breach-tips-section"
          sx={{ color: theme.palette.primary.main }}
        />,
      ],
      hideReportItemsCount: true,
    },
    {
      href: '#dark-web-faq-section',
      sectionId: '#dark-web-faq-section',
      labelText: 'FAQs',
      icons: [
        <HelpRounded
          key="dark-web-faq-section"
          sx={{ color: theme.palette.primary.main }}
        />,
      ],
      hideReportItemsCount: true,
    },
    {
      href: '#dark-web-coverage-section',
      sectionId: '#dark-web-coverage-section',
      labelText: 'Scan Coverage',
      icons: [
        <CustomIcons.ScanCoverageIcon
          key="dark-web-coverage-section"
          sx={{
            color: theme.palette.primary.main,
            fontSize: '1.5rem',
          }}
        />,
      ],
      hideReportItemsCount: true,
    },
  ];
};
// END HELPER_FUNCTIONS
